/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SelectorCustomInput/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneCustomOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneCustomOptions/index'
import TysiaSelectOneHeader from 'DesignSystem/TysiaSelectOne/TysiaSelectOneHeader/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneLabel from 'DesignSystem/TysiaSelectOne/TysiaSelectOneLabel/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'



/** @type {import('Simple/types.js').View} */
export default function SelectorCustomInput({
  children,
  viewPath = "/DesignSystem/TysiaInputQuestion/SelectorCustomInput",
  onChange,
  size,
  disabled,
  maxWidth,
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0
  
}) {
let questionAnswerValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'answer',
})
let questionAnswerChangeData = fromData.useDataChange({ viewPath,
context: 'question',
path: 'answer',
})
let questionOptionsValueData = fromData.useDataFormat({ viewPath,
context: 'question',
path: 'options',
format: fromHelpers.getDropdownOptions,
})
let questionNameValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'name',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 data="question.answer"
 value={questionAnswerValueData}
 onChange={questionAnswerChangeData}
 data="question.options"
 format="helpers.js getDropdownOptions"
 from={questionOptionsValueData}
 size={size}
 disabled={disabled}
 maxWidth={maxWidth}
 marginTop={marginTop}
 marginBottom={marginBottom}
 marginLeft={marginLeft}
 marginRight={marginRight}
 optionsWidth={300}
 customOptionsAvailable={true}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneHeader
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneHeader`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneLabel`}
 data="question.name"
 text={questionNameValueData}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
 marginLeft={dtSpaceXxs}
/>
</React.Fragment>
)}
</TysiaSelectOneHeader>
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneCustomOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneCustomOptions`}
/>
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
</React.Fragment>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
</React.Fragment>
)}
</TysiaSelectOne>
{children}
</React.Fragment>)
}